
import template from './control_panel.html';

var ControlPanelViewModel = function(page)
{
	var self = this;
	self.page = page;

	this.account_installation_id = ko.observable();
	this.installation_uuid = ko.observable();
	this.installation_type = ko.observable();
	this.product_name = ko.observable();
	this.status = ko.observable();
	this.latest_product_version = ko.observable();
	this.current_product_version = ko.observable({});
	this.account_info_list = ko.observableArray();
	this.product_version_list = ko.observableArray();
	this.product_version_id = ko.observable();
	this.product_feature_list = ko.observableArray();

	this.product = ko.observable();
	this.database = ko.observable();
	this.port = ko.observable();
	this.fqdn = ko.observable();
	this.date_installed = ko.observable();
	this.time_active = ko.observable();
	this.product_versions = ko.observableArray();
	this.available_products = ko.observableArray();

	this.installation_versions = ko.observableArray([]);

	this.extra_scripts = ko.observableArray([]);
	this.selected_extra_script = ko.observable();
	this.extra_script_deployments = ko.observableArray([]);

}

var ControlPanelClass = function(bindings)
{
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new ControlPanelViewModel(this);
	this.name = 'Control Panel';

	this.init = function() {
		self.viewModel.installation_uuid(bindings.installation_uuid);
		self.viewModel.product_name(bindings.product_name);
		self.viewModel.status(bindings.status);

		self.updateData();
	};

	this.updateData = () => {
		this.viewModel.product_version_id(null);
		this.viewModel.selected_extra_script(null);

		this.get_account_details()
		.then((res) => {
			this.get_installation_versions(this.viewModel.account_info_list().account_installation_id);
			this.get_extra_scripts(this.viewModel.current_product_version().product_version_id);
			this.get_extra_script_deployments(this.viewModel.account_info_list().account_installation_id);
		})
	}

	this.get_extra_scripts = async (_product_version_id) => {
		return $.postJSON('/grape/list',
			{
				schema: 'account',
				tablename: 'extra_script',
				sortfield: 'extra_script_id',
				filter: [
					{field: 'product_version_id', operand: '=', value: _product_version_id}
				]
			},
			(res)=>{
				let extra_scripts = res.records || [];
				extra_scripts = extra_scripts.filter((extra_script)=>{
					switch (extra_script.package_status){
						case 'development':
							return ['development'].includes(this.viewModel.account_info_list().installation_type);
						case 'qa':
							return ['development', 'qa'].includes(this.viewModel.account_info_list().installation_type);
						case 'production':
							return ['development', 'qa', 'production'].includes(this.viewModel.account_info_list().installation_type);
						default:
							return false;
					}
				});
				this.viewModel.extra_scripts(extra_scripts);
			}
		);
	}

	this.get_extra_script_deployments = async (_account_installation_id) => {
		return $.postJSON('/grape/list',
			{
				schema: 'account',
				tablename: 'v_extra_script_deployments',
				sortfield: 'date_updated',
				sortorder: 'DESC',
				filter: [
					{field: 'account_installation_id', operand: '=', value: _account_installation_id}
				]
			},
			(res)=>{
				this.viewModel.extra_script_deployments(res.records || []);
			}
		);
	}

	this.get_installation_versions = async (_account_installation_id) => {
		return $.postJSON('/grape/list',
			{
				schema: 'account',
				tablename: 'v_installation_versions',
				sortfield: 'date_inserted',
				sortorder: 'DESC',
				filter: [
					{field: 'account_installation_id', operand: '=', value: _account_installation_id}
				]
			},
			(res)=>{
				this.viewModel.installation_versions(res.records || []);
			}
		);
	}

	// TODO move away from this function or at least modularize the contents
	this.get_account_details = async () => {
		return $.postJSON('/account/get_account_details', {installation_uuid: self.viewModel.installation_uuid()}, (res) => {

			self.viewModel.latest_product_version(res.latest_product_version);
			self.viewModel.current_product_version(res.current_product_version);

			//self.viewModel.product_feature_list(res.product_feature_list[0]);
			self.viewModel.account_info_list(res.account_info_list);

			self.viewModel.product(res.account_info_list.product_name);
			self.viewModel.database(res.account_info_list.database_name);
			self.viewModel.port(res.account_info_list.port);
			this.viewModel.fqdn(res.account_info_list.fqdn);
			this.viewModel.installation_type(res.account_info_list.installation_type)

			if (res.product_version_list) {
				self.viewModel.product_versions(res.product_version_list.sort((a, b)=>b.seq-a.seq));
				self.viewModel.product_version_list(res.product_version_list[0]);
				self.viewModel.date_installed(moment(res.product_version_list[0].date_inserted).format("YYYY-MM-DD"));
				self.viewModel.time_active(moment(res.product_version_list[0].date_inserted).format("YYYY-MM-DD"));
			}

			self.viewModel.status(res.account_info_list.status);

		});
	}

	this.onClose = function() {
	};

	this.btnclose = function() {
		self.close(false);
	};

	this.btnStop = function() {
		$.postJSON('/psam/api/account/installation/save', {account_id:self.viewModel.account_info_list().account_id,installation_uuid: self.viewModel.installation_uuid(), status:'Pending Stop'}, function(res) {
			self.updateData();
		});
	};

	this.btnStart = function() {
		$.postJSON('/psam/api/account/installation/save', {account_id:self.viewModel.account_info_list().account_id,installation_uuid: self.viewModel.installation_uuid(), status:'Pending Start'}, function(res) {
			self.updateData();
		});
	};

	this.btnBackupRequest = () => {
		Grape.show_dialog(
			'DataInput',
			{
				title: 'Request Installation Backup',
				fields:[
					{type: 'text_readonly', name: 'Reminder', default_value: 'Please note Encryption Password for later!'},
					{type: 'password', name: 'password', label: 'Encryption Password'},
					{type: 'password', name: 'confirm_password', label: 'Confirm Encryption Password'}
				]
			},
			{
				onClose: (enc_password) => {
					if (!enc_password)
						return;

					if (enc_password.password !== enc_password.confirm_password) {
						Grape.alert({
							title: 'Password Mismatch',
							type: 'error',
							message: "Passwords don't match. Please try again.", onClose:()=>{
							this.btnBackupRequest();
						}});
						return;
					}

					let b64EncodeUnicode = (str) => {
						return window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
							return String.fromCharCode(parseInt(p1, 16))
						}))
					}

					let payload = {
						installation_uuid: self.viewModel.account_info_list().installation_uuid,
						enc_password: b64EncodeUnicode(enc_password.password)
					}

					$.postJSON('/psam/api/account/installation/backup/request', payload, function(res) {
						if (res.status !== 'OK')
							Grape.alert_api_error(res);

						Grape.alert({
							title: 'Backup Requested',
							type: 'success',
							message: "Your backup has been requested, when it is ready you will receive an email with a link to download your backup."});
					});

				}
			}
		);
	};

	this.btnDeleteInstallation = () => {
		Grape.alert_prompt({
			type: 'warning',
			title: 'Delete Installation',
			message: '<b>Are you sure you want to delete your installation and its related data?<br><br> This operation is irreversible!</b>',
			onClose: (accept) => {
				if (accept) {
					$.postJSON('psam/api/account/installation/save',
						{
							account_id:self.viewModel.account_info_list().account_id,
							installation_uuid: self.viewModel.account_info_list().installation_uuid,
							status: 'Pending Uninstall'
						},
						(res) => {
							if (res.status === 'ERROR'){
								Grape.alert_api_error(res);
								return;
							}

							this.close();
						}
					);
				}
			}
		});
	};

	this.btnViewAwxJobStdout = async (job_id) => {
		// let job_id = self.viewModel.account_info_list().job_id;
		$.getJSON(`pscm/api/awx/job/${job_id}/stdout`, {}, (response)=>{
			let tab = window.open('', '_blank');
			tab.document.write(`<code style="white-space:pre">${response.stdout}</code>`);
			tab.document.close();
		});
	};

	this.btnUpgrade = () => {
		$.postJSON('/psam/api/account/installation/upgrade',
			{
				account_id: self.viewModel.account_info_list().account_id,
				installation_uuid: self.viewModel.installation_uuid(),
				product_version_id : self.viewModel.product_version_id(),
				status: 'Pending Upgrade'
			}
		)
		.then(()=>{
			Grape.show_dialog('ConfirmAccountDialog',
				{ installation_uuid: self.viewModel.installation_uuid() },
				{ onClose: () => { self.updateData(); } }
			);
		});
	};

	this.edit_status = ()=>{
		Grape.show_dialog(
			'DataInput',
			{
				title: 'Edit Status',
				fields:[
					{
						type: 'list',
						label: 'Status',
						name: 'status',
						default_value: this.viewModel.account_info_list().status,
						list: [
							"Pending Activation",
							"Pending Install",
							"Installing",
							"Installed",
							"Installation Error",
							"Pending Uninstall",
							"Uninstalling",
							"Uninstalled",
							"Uninstall Error",
							"Pending Upgrade",
							"Upgrading",
							"Upgraded",
							"Upgrade Error",
							"Pending Start",
							"Starting",
							"Started",
							"Start Error",
							"Pending Stop",
							"Stopping",
							"Stopped",
							"Stop Error",
							"Error"
						]
					}
				]
			},
			{
				onClose: (status) => {
					if (!status)
						return;

					let payload = {
						account_id: this.viewModel.account_info_list().account_id,
						installation_uuid: self.viewModel.account_info_list().installation_uuid,
						status: status.status,
						checks: false
					};

					$.postJSON('/psam/api/account/installation/save', payload, (res) => {
						if (res.status !== 'OK'){
							Grape.alert_api_error(res);
							return;
						}

						Grape.alert({
							title: 'Status Updated',
							type: 'success',
							message: "The status has been successfully updated"
						});

						this.updateData();
					});

				}
			}
		);
	};

	this.inputDeploymentArgs = async (default_value) => {
		return new Promise((resolve, reject) => {
			Grape.show_dialog(
				'DataInput',
				{
					title: 'Extra Script Deployment JSON Args',
					fields:[
						{type: 'text', name: 'deployment_args_json', label: default_value || '{}', default_value: '{}'}
					]
				},
				{
					onClose: (input) => {
						if (!input || !input.deployment_args_json)
							input = {deployment_args_json:'{}'};

						try {
							JSON.parse(input.deployment_args_json);
						}
						catch (err){
							Grape.alert({
								type:'error',
								title:'Invalid Deployment Args',
								message: 'The deployment args you provided is not valid json, please try again.',
								onClose: ()=>{ resolve(this.inputDeploymentArgs(input.deployment_args_json)) }
							});
							return;
						}
						resolve(input.deployment_args_json);
					}
				}
			);
		});
	}

	this.btnDeployExtraScript = async() => {
		let deployment_args_json = await this.inputDeploymentArgs();

		Grape.alert_prompt({
			title: 'Deploy Extra Script',
			type: 'warning',
			message: `Deploy extra-script<br><b>${this.viewModel.selected_extra_script().name}</b><br>on<br><b>${this.viewModel.account_info_list().fqdn}</b><br>with args<br><b>${deployment_args_json}</b><br>???`,
			accept_text: 'Yes',
			cancel_text: 'No',
			onClose: (answer) => {
				if (answer) {
					$.postJSON('/psam/api/extra-script/deployment/save',
						{
							account_installation_version_id: self.viewModel.account_info_list().account_installation_version_id,
							extra_script_id: self.viewModel.selected_extra_script().extra_script_id,
							status: 'deploy',
							deployment_args: deployment_args_json
						}
					)
					.then((res)=>{
						if (res.status && res.status !== 'OK'){
							Grape.alert_api_error(res);
							return;
						}

						Grape.alert({title:'', message:'Deploying extra script', type:'success'});
						this.get_extra_script_deployments(this.viewModel.account_info_list().account_installation_id);
					});
				}
			}
		});

	};

}

//Register the dialog
export default {
	name: 'ControlPanel',
	dialog_class: ControlPanelClass,
	template: template
};
